import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const STATUSES = ["new", "confirmed", "cancelled"];
const LABEL = { new: "Nuova", confirmed: "Confermata", cancelled: "Annullata" };

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const load = () => api.get("/admin/bookings").then((r) => setBookings(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/bookings/${id}`, { status });
    toast.success("Stato aggiornato");
    load();
  };

  const remove = async (b) => {
    if (!window.confirm(`Eliminare definitivamente la richiesta di ${b.full_name}? L'operazione non è reversibile.`)) return;
    try {
      await api.delete(`/admin/bookings/${b.id}`);
      toast.success("Richiesta eliminata");
      load();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    }
  };

  return (
    <div data-testid="admin-bookings">
      <h1 className="font-serif font-light text-4xl text-petrol mb-2">Richieste di prenotazione</h1>
      <p className="text-muted-foreground mb-8">Le richieste dirette ricevute dal sito</p>

      <div className="bg-card border border-line rounded-sm overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-beige text-petrol/70">
            <tr>
              <th className="text-left px-5 py-3 font-medium">Ospite</th>
              <th className="text-left px-5 py-3 font-medium">Contatti</th>
              <th className="text-left px-5 py-3 font-medium">Appartamento</th>
              <th className="text-left px-5 py-3 font-medium">Date</th>
              <th className="text-left px-5 py-3 font-medium">Ospiti</th>
              <th className="text-left px-5 py-3 font-medium">Stato</th>
              <th className="text-left px-5 py-3 font-medium">Azioni</th>
            </tr>
          </thead>
          <tbody>
            {bookings.length === 0 && (
              <tr><td colSpan={7} className="px-5 py-8 text-center text-muted-foreground">Nessuna richiesta.</td></tr>
            )}
            {bookings.map((b) => (
              <tr key={b.id} className="border-t border-line" data-testid={`booking-row-${b.id}`}>
                <td className="px-5 py-3 text-petrol font-medium">{b.full_name}</td>
                <td className="px-5 py-3 text-muted-foreground">{b.email}<br />{b.phone}</td>
                <td className="px-5 py-3 text-muted-foreground">{b.apartment_name}</td>
                <td className="px-5 py-3 text-muted-foreground">{b.arrival_date} → {b.departure_date}</td>
                <td className="px-5 py-3 text-muted-foreground">{b.guests}</td>
                <td className="px-5 py-3">
                  <select value={b.status} onChange={(e) => setStatus(b.id, e.target.value)} data-testid={`booking-status-${b.id}`}
                    className="border border-line rounded-sm px-2 py-1 text-petrol bg-cream text-xs outline-none">
                    {STATUSES.map((s) => <option key={s} value={s}>{LABEL[s]}</option>)}
                  </select>
                </td>
                <td className="px-5 py-3">
                  <button onClick={() => remove(b)} data-testid={`delete-booking-${b.id}`}
                    title="Elimina richiesta" className="flex items-center gap-1 text-destructive hover:opacity-70 text-xs">
                    <Trash2 size={14} /> Elimina
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
